import React, { Fragment, useEffect } from "react"

import PropTypes from "prop-types"

import "./index.less"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { compose } from "redux"

import SummaryWidgets from "../SummaryWidgets"
import { Spin } from "antd"
import { LOCAL_CHECKBOX_EXCLUDE, LOCAL_ISOLATED_METRICS, isAmbassadorActive } from "../../../utils/storage"
import WidgetResultByDimensionAmbassador from "./components/WidgetResultByDimensionAmbassador"
import WidgetResultByDimension from "./components/WidgetResultByDimension"
import WidgetResultByDivision from "./components/WidgetResultByDivision"
import WidgetAnalysisSegment from "../WidgetAnalysisSegment"
import WidgetQualitativeQuestion from "../WidgetQualitativeQuestion"
import { validate } from "../../../utils/functions"
import WidgetRightChartEnps from "./components/WidgetRightChartEnps"
import WidgetMultipleChoiceQuestions from "../WidgetMultipleChoiceQuestions"
import SummaryQuestions from "../SummaryQuestions"
import WidgetResume from "../WidgetResume"
import { get } from "lodash"
import { verifyFeatureFlag } from "../../../utils/feature-flags"
import { getDimensionsDataWatcher } from "./actions"
import reducer from "./reducer"
import saga from "./saga"
import { createStructuredSelector } from "reselect"
import { makeSelectDimensionsData, makeSelectIsLoadingDimensionsData } from "./selectors"
import { connect } from "react-redux"

export function ClimateMeasurement(props) {

  useEffect(() => {
    initGetData()
  }, [props.idMeasure, props.idDivisionSelected])

  const initGetData = () => {
    const {
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
      divisionsData
    } = props
    const params = {
      isHome: true,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      history,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() == "true" &&
        LOCAL_ISOLATED_METRICS() == "true",
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    }
    if (measureGeneral.is_engagement) {
      params.dimensionType = "Engagement"
      params.is_engagement = true
    } else {
      params.is_engagement = false
    }

    props.getDimensionsData(params)
  }

  const hasSegment = props.measureGeneral.segments.length > 0
  const renderResultByDimension = () => {
    const {
      typeMeasurement,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      selectedSegment,
      dimensionsData
    } = props
    if (!validate.exist(idMeasure)) {
      return null
    }

    if (isAmbassadorActive()) {
      return (
        <WidgetResultByDimensionAmbassador
          typeMeasurement={typeMeasurement}
          idMeasure={idMeasure}
          measureTotal={measureTotal}
          measureGeneral={measureGeneral}
          idDivisionSelected={idDivisionSelected}
          idDivisionParent={idDivisionParent}
          selectedSegment={selectedSegment}
        />
      )
    }
    return (
      <WidgetResultByDimension
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
        dimensionsData={dimensionsData}
      />
    )
  }
  const renderResultEnps = () => {
    const {
      measureGeneral,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
    } = props
    if (!measureGeneral.has_enps) {
      return null
    }
    return (
      <WidgetRightChartEnps
        idMeasure={idMeasure}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
      />
    )
  }
  const renderResultByDivision = () => {
    const {
      typeMeasurement,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      selectedSegment,
      dimensionsData,
      divisionsData
    } = props
    if (!validate.exist(idMeasure)) {
      return null
    }
    /* if (
      validate.exist(idDivisionSelected) ||
      validate.exist(idDivisionParent)
    ) {
      return null
    } */
    return (
      <WidgetResultByDivision
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
        dimensionsData={dimensionsData}
        divisionsData={divisionsData}
      />
    )
  }

  const renderSegmentAnalysis = () => {
    const {
      typeMeasurement,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props

    if (measureGeneral.segments.length >1 && !verifyFeatureFlag('seg2-5') &&  (selectedSegment === 0 || selectedSegment === null)){
      return null
    }

    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null)
      && measureGeneral.new_version === 0
    ) {
      return null
    }

    let newSelectedSegment = selectedSegment

    if (measureGeneral.segments.length === 1) {
      newSelectedSegment = measureGeneral.segments[0].id_segment
    }

    return (
      <WidgetAnalysisSegment
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={newSelectedSegment}
      />
    )
  }

  const renderQualitativeQuestions = () => {
    const {
      typeMeasurement,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props
    if (
      (isAmbassadorActive() &&
        !measureGeneral.ambassador_qualitative_results_visible) ||
      !validate.exist(idMeasure)
    ) {
      return null
    }
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null)
    ) {
      return null
    }
    return (
      <WidgetQualitativeQuestion
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
      />
    )
  }

  const renderMultipleChoiceQuestions = () => {
    const {
      typeMeasurement,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureTotal,
      measureGeneral,
      selectedSegment,
    } = props
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null)
    ) {
      return null
    }
    return (
      <WidgetMultipleChoiceQuestions
        typeMeasurement={typeMeasurement}
        idMeasure={idMeasure}
        measureTotal={measureTotal}
        measureGeneral={measureGeneral}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
      />
    )
  }

  const renderSummaryQuestions = () => {
    const {
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null)
    ) {
      return null
    }
    return (
      <SummaryQuestions
        idMeasure={idMeasure}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
      />
    )
  }

  const renderEvolutionAndResult = () => {
    const {
      measureTotal,
      idDivisionSelected,
      idMeasure,
      measureGeneral,
      idDivisionParent,
      selectedSegment,
    } = props
    const isLeadership = false
    return (
      <WidgetResume
        measureGeneral={measureGeneral}
        idMeasure={idMeasure}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        className="WidgetResume boxShadow"
        measureData={measureTotal}
        isLeadership={isLeadership}
        selectedSegment={selectedSegment}
        title={
          <Fragment>
            <b>
              {isLeadership
                ? TYPE_SURVEY.leadership.nameSurveyType
                : setNameMetricsTotalLabel()}
            </b>
          </Fragment>
        }
        withEmpty
      />
    )
  }

  const setNameMetricsTotalLabel = () => {
    const { measureGeneral, selectedSegment } = props
    let surveyType = get(measureGeneral, "id_survey_type", null)
    let hasLabel = get(measureGeneral, "metric_total_label", null)
    let response = get(measureGeneral, "survey_type_name", null)
    // let response = "Clima laboral"
    // if (surveyType != 1 && hasLabel !== null) {
    // }

    if (selectedSegment) {
      response = `${response} - ${get(measureGeneral, "segment_name", "")}`
    }
    return response
  }

  if (props.isLoading || props.isLoadingDimensionsData) {
    return (
      <div>
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      </div>
    )
  }

  return (
    <div>
      {renderEvolutionAndResult()}
      {renderSummaryQuestions()}
      <SummaryWidgets
        typeMeasurement={props.typeMeasurement}
        idMeasure={props.idMeasure}
        measureTotal={props.measureTotal}
        measureGeneral={props.measureGeneral}
        idDivisionSelected={props.idDivisionSelected}
        idDivisionParent={props.idDivisionParent}
        selectedSegment={props.selectedSegment}
        hasSegment={hasSegment}
      />
      <div style={{ display: "flex" }}>
        {renderResultByDimension()}
        {/* renderResultEnps() */}
      </div>
      {renderResultByDivision()}
      {renderSegmentAnalysis()}
      {renderQualitativeQuestions()}
      {renderMultipleChoiceQuestions()}
    </div>
  )
}

ClimateMeasurement.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoading: PropTypes.bool,
  selectedSegment: PropTypes.number,
  isLoadingDimensionsData: PropTypes.bool,
  dimensionsData: PropTypes.object,
  divisionsData: PropTypes.object
}

const mapStateToProps = createStructuredSelector({
  isLoadingDimensionsData: makeSelectIsLoadingDimensionsData(),
  dimensionsData: makeSelectDimensionsData(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDimensionsData: params => dispatch(getDimensionsDataWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "climateMeasurement", reducer })
const withSaga = injectSaga({ key: "climateMeasurement", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(ClimateMeasurement)